import { uniqBy, orderBy } from 'lodash';

export default function DisasterData(currentMode, currentArea, datas, dataTime) {
  let datasFilter = datas;
  if (currentMode === 'province' && currentArea.code > 0) {
    datasFilter = datas.filter((d) => d.province_code === currentArea.code);
  }

  const dataListUniq = uniqBy(datasFilter, 'province_name');
  const dataList = orderBy(dataListUniq, ['tambon_name'], ['asc']);
  const dataListTambon = orderBy(datasFilter, ['province_name'], ['asc']);

  const countList = dataList.length;

  return ({
    count: countList,
    list: dataList,
    dataListTambon,
    dataTime,
  });
}
